import React from 'react';
import { Box } from '@mui/material';
import useInterveneSx from '../../hooks/useInterveneSx';
import {
  getContextDrawerTabPanelId,
  getContextDrawerTabId,
} from '../../constants/contextDrawerTabs';

export default function ContextDrawerTabPanel({
  tabId,
  activeTab,
  children,
  footer,
  fillHeight = false,
}) {
  const styles = useInterveneSx().contextDrawer;
  const isActive = activeTab === tabId;

  return (
    <Box
      role="tabpanel"
      hidden={!isActive}
      id={getContextDrawerTabPanelId(tabId)}
      aria-labelledby={getContextDrawerTabId(tabId)}
      sx={{
        ...styles.tabPanel,
        display: isActive ? 'flex' : 'none',
      }}
    >
      <Box sx={fillHeight ? styles.tabPanelFill : styles.tabPanelScroll}>
        {children}
      </Box>
      {footer ? <Box sx={styles.tabPanelFooter}>{footer}</Box> : null}
    </Box>
  );
}
